$(document).ready(() => {
    class DependentFormHandler {
        constructor(forms) {
            this.forms = forms;
            this.hiddenClass = "dependent-hidden";
            this.init();
        }

        init() {
            this.forms.forEach(form => {
                this.setupDependentFields(form);
                this.setupSubmitButtonValidation(form);
            });
        }

        setupDependentFields(form) {
            form.querySelectorAll('span[data-dependent="1"]').forEach(dependentSpan => {
                const parentDiv = dependentSpan.closest(".clearfix");
                if (!parentDiv) return;
                parentDiv.classList.add(this.hiddenClass);

                const identifier = `${form.id}-${dependentSpan.dataset.dependentIdentifier}`;
                const triggers = form.querySelectorAll(`#${identifier}, #${identifier} input, #${identifier} select`);

                triggers.forEach(trigger => {
                    trigger.addEventListener("change", () => {
                        this.toggleVisibility(triggers, dependentSpan.dataset.dependentSelectOption, parentDiv);
                        this.updateSubmitButtonState(form); // Jetzt erst den Button aktualisieren!
                    });
                });

                // Initial visibility check
                this.toggleVisibility(triggers, dependentSpan.dataset.dependentSelectOption, parentDiv);
                this.updateSubmitButtonState(form);
            });
        }

        toggleVisibility(triggers, expectedValue, parentDiv) {
            const isVisible = Array.from(triggers).some(input => {
                if (input.type === "checkbox" || input.type === "radio") {
                    return input.checked && (!expectedValue || input.value === expectedValue);
                } else if (input.type === "select-multiple" && input.multiple) {
                    return Array.from(input.selectedOptions).some(option => option.value === expectedValue);
                } else {
                    return (input.value === expectedValue || (input.tagName === "SELECT" && input.value)) === true;
                }
            });

            parentDiv.classList.toggle(this.hiddenClass, !isVisible);
        }


        updateSubmitButtonState(form) {
            const submitButton = form.querySelector("button[type='submit'], input[type='submit']");
            if (!submitButton) return;
            submitButton.disabled = !this.areAllDependentFieldsValid(form);
        }

        areAllDependentFieldsValid(form) {
            return Array.from(form.querySelectorAll('span[data-dependent-required="1"]')).every(span => {
                const parentDiv = span.closest(".clearfix");

                // Falls das Feld nicht existiert oder versteckt ist, ignorieren
                if (!parentDiv || parentDiv.classList.contains(this.hiddenClass)) return true;

                return Array.from(parentDiv.querySelectorAll("input, select, textarea"))
                    .filter(input => input.type !== "hidden") // Hidden-Felder ignorieren
                    .some(input => {
                        if (input.type === "checkbox" || input.type === "radio") {
                            return input.checked;
                        }
                        return input.value.trim() !== "";
                    });
            });
        }

        setupSubmitButtonValidation(form) {
            const submitButton = form.querySelector("button[type='submit'], input[type='submit']");
            if (!submitButton) return;

            this.updateSubmitButtonState(form);

            form.querySelectorAll("input, select, textarea").forEach(input => {
                input.addEventListener("change", () => this.updateSubmitButtonState(form));
            });

            this.addRequiredAsterisk(form);
        }

        addRequiredAsterisk(form) {
            form.querySelectorAll('span[data-dependent-required="1"]').forEach(field => {
                const label = field.closest(".clearfix")?.querySelector("label");
                if (label && !label.querySelector(".required")) {
                    label.insertAdjacentHTML("beforeend", ' <span class="required">*</span>');
                }
            });
        }
    }

    new DependentFormHandler(document.querySelectorAll(".neos-form-builder form"));
});
